import axios from 'axios';


export const getFlagsConfig = (callback = () => null) => {
  axios.get(process.env.REACT_APP_FLAGS_URL)
  .then(callback)
  .catch(console.log);
}